import { render } from "./ProductShare.vue?vue&type=template&id=748f5bc9&scoped=true"
import script from "./ProductShare.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductShare.vue?vue&type=script&setup=true&lang=js"

import "./ProductShare.vue?vue&type=style&index=0&id=748f5bc9&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748f5bc9"],['__file',"resources/js/components/whatsapp-managment/includes/types/ProductShare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "748f5bc9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('748f5bc9', __exports__)) {
    console.log('reload')
    api.reload('748f5bc9', __exports__)
  }
  
  module.hot.accept("./ProductShare.vue?vue&type=template&id=748f5bc9&scoped=true", () => {
    console.log('re-render')
    api.rerender('748f5bc9', render)
  })

}


export default __exports__